///-------------------------------------------------------------------------------------------------
// summary:	Authentication service class
//
//    NOTE: This is a V2 (PUBLIC Integration) compatible service.
//
///-------------------------------------------------------------------------------------------------

import Api from './Api';

export default {
  
  signup(signupData) {
    const response = Api().post('/public/signup', signupData);
    return response;
  },
  
  login(credentials) {
    const response = Api().post('/public/login', credentials);
    return response;
  },
  
  logout(credentials) {
    const response = Api().post('/public/logout', credentials);
    return response;
  },
  
  lookupSignupCode( signupCode ) {
    const response = Api().post( '/public/verifySignupCode', signupCode )
    return "";
  },

  // This just takes the current user details (since we have a token) and reauthorize; creating a new
  // token and returning the proper user details.
  authorize() {
    const response = Api().post("/public/authorize");
    return response;
  },
  
  forgotPassword(email) {
    const response = Api().post("/public/forgotPassword", {email: email});
    return response;
  },
  resetPassword( user ) {
    const response = Api().post( `/public/resetPassword/${user.email}` , user );
    return response;
  }
 
}
